import { connect } from 'react-redux';
import { selectPractitioners, selectPractitionersIsLoading } from '../Practitioners.selectors';
import PractitionersList from './PractitionersList';

const mapStateToProps = state => ({
  practitioners: selectPractitioners(state),
  isLoading: selectPractitionersIsLoading(state),
});

export default connect(mapStateToProps)(PractitionersList);
